export default __webpack_public_path__ + "static/media/avatar.769a6cfa.png";